var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00005 6.59999L9.90005 0.699987C10.0834 0.516654 10.3167 0.424988 10.6 0.424988C10.8834 0.424988 11.1167 0.516654 11.3 0.699987C11.4834 0.883321 11.575 1.11665 11.575 1.39999C11.575 1.68332 11.4834 1.91665 11.3 2.09999L4.70005 8.69999C4.50005 8.89999 4.26672 8.99999 4.00005 8.99999C3.73338 8.99999 3.50005 8.89999 3.30005 8.69999L0.700048 6.09999C0.516715 5.91665 0.425049 5.68332 0.425049 5.39999C0.425049 5.11665 0.516715 4.88332 0.700048 4.69999C0.883382 4.51665 1.11672 4.42499 1.40005 4.42499C1.68338 4.42499 1.91672 4.51665 2.10005 4.69999L4.00005 6.59999Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCheck);
export default __webpack_public_path__ + "static/media/purple-check.0cea2e8f45dd6338378df269cf451d81.svg";
export { ForwardRef as ReactComponent };